import { useParams } from 'react-router-dom';
import TopicContentRenderer from '../components/TopicContentRenderer';
import ThematicNotFound from '../components/ThematicNotFound';
import { getTopicBySlug, getTopicsByTheme, themes, topicContentBySlug } from '../data';

export default function TopicPage() {
    const { themeSlug, topicSlug } = useParams<{ themeSlug: string; topicSlug: string }>();

    const theme = themes.find((candidate) => candidate.slug === themeSlug);
    if (!theme || !themeSlug) {
        return (
            <ThematicNotFound
                title="Theme not found"
                message="The requested theme does not exist. Please return to Thematic Studies."
            />
        );
    }

    if (!topicSlug) {
        return (
            <ThematicNotFound
                title="Topic not found"
                message="The requested topic does not exist. Please return to the theme topic list."
            />
        );
    }

    const topic = getTopicBySlug(topicSlug);
    const content = topicContentBySlug[topicSlug];
    const topicBelongsToTheme = getTopicsByTheme(theme.id).some((themeTopic) => themeTopic.slug === topicSlug);

    if (!topic || !content || !topicBelongsToTheme) {
        return (
            <ThematicNotFound
                title="Topic not found"
                message="The requested topic does not exist. Please return to the theme topic list."
            />
        );
    }

    return <TopicContentRenderer topic={topic} content={content} />;
}
